<template>
	<div :id="ad.id" class="medianet-ad"></div>
</template>

<script>
export default {
	props: {
		ad: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	methods: {
		initObserver(adId) {
			const self = this;
			const options = {
				rootMargin: `0px 0px 400px 0px`
			};
			const observer = new IntersectionObserver(
				self.observeIntersection,
				options
			);

			[...document.querySelectorAll(adId)].forEach(el => {
				observer.observe(el);
			});
		},

		observeIntersection(entries) {
			const self = this;
			entries.forEach(entry => {
				self.currentY = window && window.pageYOffset;
				if (self.currentY >= self.previousY) {
					if (entry.isIntersecting) {
						if (!entry.target.hasChildNodes()) {
							try {
								const mnetadId = self.ad.id;
								let version = self.ad.artNum === 1 ? '657189198' : '525941827';
								if (
									window &&
									window._mNHandle &&
									window._mNHandle.queue
								) {
									window._mNHandle.queue.push(function() {
										window._mNDetails.loadTag(
											mnetadId,
											"300x50",
											version
										);
									});
								}
							} catch (error) {}
						}
					}
				}
				self.previousY = self.currentY;
			});
		}
	},
	mounted() {
		const element = `#${this.ad.id}`;
		this.initObserver(element);
	}
};
</script>

<style lang="scss">
@media screen and (max-width: 47.938rem) {
	.medianet-ad {
		min-height: 11.5rem;
	}
}
</style>
